import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import "./SubmitSummary.css";
import LoanApplicationInformationSection from "../loanApplicationInformationSection/LoanApplicationInformationSection";
import ApplicantSection from "../applicantSection/ApplicantSection";
import CollateralEquitySection from "../collateralEquitySection/CollateralEquitySection";
import DealerPurchaseSection from "../dealerPurchaseSection/DealerPurchaseSection";
import EntityApplicantSection from "../entityApplicantSection/EntityApplicantSection";
import FixedAssetSection from "../fixedAssetSection/FixedAssetSection";
import GapFinancingSection from "../gapFinancingSection/GapFinancingSection";
import LendingReferenceSection from "../lendingReferenceSection/LendingReferenceSection";
import OperatingLoanSection from "../operatingLoanSection/OperatingLoanSection";
import RefinanceDebtSection from "../refinanceDebtSection/RefinanceDebtSection";
import ProductionLineOfCreditSection from "../productionLineOfCreditSection/ProductionLineOfCreditSection";
import AuctionInformationSection from "../auctionInformationSection/AuctionInformationSection";
import { LoanType } from "shared/Enums";

interface SubmitSummaryProps {
  loanDetails: LoanApplication
}

export default class SubmitSummary extends React.Component<SubmitSummaryProps> {
  render() {
    return (
      <>
        {/* Top Level Loan Application Information */}
        <div className="loan-application-details-section"></div>
        <LoanApplicationInformationSection
          loanDetails={this.props.loanDetails}
          summary={true}
        />

        {/* Fixed Asset Items */}
        <div className="loan-application-details-section">
          <FixedAssetSection
            loanDetails={this.props.loanDetails}
          />
        </div>


        {/* Dealer Purchase Items */}
        <div className="loan-application-details-section">
          <DealerPurchaseSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Auction Information Items */}
        <div className="loan-application-details-section">
          <AuctionInformationSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Gap Financing Items */}
        <div className="loan-application-details-section">
          <GapFinancingSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Production Line of Credit Items */}
        <div className="loan-application-details-section">
          <ProductionLineOfCreditSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Main Lending Reference Items */}
        <div className="loan-application-details-section">
          <LendingReferenceSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {this.props.loanDetails.loanType !== LoanType.EquipmentAuctionPurchase &&
          <>
            {/* Collateral Equity Items */}
            <div className="loan-application-details-section">
              <CollateralEquitySection
                loanDetails={this.props.loanDetails}
              />
            </div>
          </>
        }

        {/* Refinance Debt Items */}
        <div className="loan-application-details-section">
          <RefinanceDebtSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Operating Loan Items */}
        <div className="loan-application-details-section">
          <OperatingLoanSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Individual Applicants */}
        <div className="loan-application-details-section">
          <ApplicantSection
            loanDetails={this.props.loanDetails}
          />
        </div>

        {/* Entity Applicant */}
        <div className="loan-application-details-section">
          <EntityApplicantSection
            loanDetails={this.props.loanDetails}
          />
        </div>
      </>
    );
  }
}